<template>
  <div>
    <modal
      ref="videoModal"
      class="video-component"
      :class="[
        isNotChatTab ? 'is-not-chat-tab' : 'is-chat-tab',
        isFullScreen ? 'is-fullscreen' : '',
      ]"
      id="video-component"
      name="video-component"
      :width="modalWidth"
      @before-close="$emit('beforeClose', $event)"
      @before-open="handleBeforeOpen"
    >
      <div class="video-body">
        <div class="video-header" ref="dragHeader">
          <div>
            <span>ビデオ通話</span>
            <span v-if="currentChannelUser">{{ `${currentChannelUser.family_name || ''} ${currentChannelUser.given_name ||
              ''}`.trim()
              || '-' }}
            </span>
          </div>
          <div>
            <span v-if="rtc.networkStatus" class="video-component" :class="{
              'network-high': rtc.networkStatus === networkStatus.HIGH.name,
              'network-medium': rtc.networkStatus === networkStatus.MEDIUM.name,
              'network-low': rtc.networkStatus === networkStatus.LOW.name || rtc.networkStatus === networkStatus.DISCONNECT.name,
            }">
              ネットワークの状態：{{ this.rtc.networkStatus }}
            </span>
          </div>
          <div v-if="isUserJoined || isUserLeaved">
            <transition name="slide-right-left">
              <div class="video-notification">
                {{ isUserJoined && !isUserLeaved ? '患者は診察ルームに参加しています。' : '患者は診察ルームを退出しました。' }}
              </div>
            </transition>
          </div>
        </div>

        <div class="video-controls">
          <button class="full-screen" @click="toggleFullScreen">
            <component :is="isFullScreen ? 'ShrinkIcon' : 'ExpandIcon'" />
          </button>
        </div>
        
        <img v-if="userMicOff" :src="micUserIcon" class="mic-icon-user" alt="Micro" />
        <div class="video-container">
          <div class="video-content" id="video-content"></div>
          <div class="video-content-user" id="video-content-user"></div>
        </div>
        <div class="video-footer">
          <div class="video-item" v-if="isCall">
            <button class="video-btn video-btn-plan" @click="showPlanListModal()">
              プラン一覧
            </button>
          </div>
          <div class="video-item">
            <img :src="camIcon" @click="camToggle()" alt="Camera" />
          </div>
          <div class="video-item">
            <button v-if="isCall" class="video-btn video-btn-end" @click="leaveCalling">
              退出する
            </button>
            <button v-else class="video-btn video-btn-call" id="join" :disabled="!isCanJoin" @click="joinCalling">
              開始する
            </button>
          </div>
          <div class="video-item">
            <img :src="micIcon" @click="micToggle()" alt="Micro" />
          </div>
        </div>

      </div>
    </modal>

    <PlanListPopup ref="plan-list-popup" :name="'plan-list-popup'" :is-show="isShowPlanListModal" />
  </div>
</template>

<script>
import { Action } from 'vuex-class';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AgoraRTC from 'agora-rtc-sdk-ng';
import Toast from '@common/helpers/toast';
import ApiHelper from 'api-helper';
import CamOn from '@/assets/img/camera.svg';
import CamOff from '@/assets/img/camera-lock.svg';
import MicOn from '@/assets/img/mic.svg';
import MicOff from '@/assets/img/mic-lock.svg';
import WindowSizeMixin from '@common/mixins/WindowSizeMixin';

import PlanListPopup from '@components/v2/patient/message/PlanListPopup.vue';
import ShrinkIcon from './ShrinkIcon.vue';
import ExpandIcon from './ExpandIcon.vue';

@Component({
  components: {
    PlanListPopup,
    ShrinkIcon,
    ExpandIcon,
  },
})
export default class VideoComponent extends Mixins(WindowSizeMixin) {
  @Prop() currentChannelUser;
  @Prop() isNotChatTab;
  @Action('video_call/setVideoCall') setVideoCall;

  agoraTokenData = {};
  hasMic = true;
  hasCamera = true;
  isCall = false;
  hasUser = false;
  userMicOff = false;
  isCanJoin = true;
  isUserJoined = false;
  isUserLeaved = false;
  isFullScreen = false;


  networkStatus = {
    HIGH: {
      name: '良い',
      quantity: [1, 2],
    },
    MEDIUM: {
      name: '中程度',
      quantity: [3, 4],
    },
    LOW: {
      name: '弱い',
      quantity: [5],
    },
    DISCONNECT: {
      name: '切断',
      quantity: [6],
    },
  };

  rtc = {
    localAudioTrack: null,
    localVideoTrack: null,
    client: null,
    networkQuantity: null,
    networkStatus: null,
    originalVideoConfig: null,
  };

  options = {
    // Pass your App ID here.
    appId: 'Your App ID',
    // Set the channel name.
    channel: 'test',
    // Pass your temp token here.
    token: 'Your temp token',
    // Set the user ID.
    uid: 123456,
  };

  isShowPlanListModal = false;

  resetCallState() {
    this.isUserJoined = false;
    this.isUserLeaved = false;
    this.userMicOff = false;
    this.rtc.networkStatus = null;
    this.rtc.networkQuantity = null;
    this.isCall = false;
    this.isCanJoin = true;
    this.hasMic = true;
    this.hasCamera = true;
  }

  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
  }

  get modalWidth() {
    if (this.isFullScreen) {
      return '100vw';
    }
    if (this.windowWidth <= 767) {
      return '100%';
    }
    return this.isNotChatTab ? 500 : 540;
  }

  handleBeforeOpen(event) {
    this.resetCallState();
    this.getVideoToken(event.params.currentChannel);
    setTimeout(() => {
      this.enableDragging();
    }, 50);
  }

  enableDragging() {
    const modal = document.querySelector('.v--modal-box');
    const header = this.$refs.dragHeader;

    if (!modal || !header) {
      return;
    }

    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialLeft = 0;
    let initialTop = 0;

    header.style.cursor = 'move';

    const onMouseDown = (e) => {
      isDragging = true;

      // Get initial mouse and modal position
      startX = e.clientX;
      startY = e.clientY;

      const rect = modal.getBoundingClientRect();
      initialLeft = rect.left;
      initialTop = rect.top;

      // Fix modal if there is no specific style
      modal.style.position = 'fixed';
      modal.style.margin = '0';

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = (e) => {
      if (!isDragging) {
        return;
      }

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      let newLeft = initialLeft + dx;
      let newTop = initialTop + dy;

      const modalRect = modal.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const maxLeft = windowWidth - modalRect.width;
      const maxTop = windowHeight - modalRect.height;

      newLeft = Math.min(Math.max(0, newLeft), maxLeft);
      newTop = Math.min(Math.max(0, newTop), maxTop);

      modal.style.left = `${newLeft}px`;
      modal.style.top = `${newTop}px`;
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    header.addEventListener('mousedown', onMouseDown);
  }

  micToggle() {
    this.hasMic = !this.hasMic;
    this.rtc.localAudioTrack.setEnabled(this.hasMic);
  }

  camToggle() {
    if (this.rtc.networkStatus === this.networkStatus.LOW.name) {
      return;
    }

    this.hasCamera = !this.hasCamera;
    this.rtc.localVideoTrack.setEnabled(this.hasCamera);
  }

  get camIcon() {
    return this.hasCamera ? CamOn : CamOff;
  }

  get micIcon() {
    return this.hasMic ? MicOn : MicOff;
  }

  get micUserIcon() {
    return this.userMicOff ? MicOff : MicOn;
  }

  async getVideoToken(currentChannel) {
    await ApiHelper.getApi('ChannelApi')
      .agoraToken(currentChannel.id, {
        with: 'users,latest_message,users.latestReservation',
      })
      .then((response) => {
        this.isCanJoin = false;
        this.agoraTokenData = response.data;
        this.options = {
          appId: response.data.app_id,
          channel: response.data.channel_uuid,
          token: response.data.token,
          uid: Number(response.data.uid),
        };
        this.startBasicCall();
        this.isCanJoin = true;
      })
      .catch((error) => {
        if (error.response) {
          Toast.error(error.response.data.message);
        }
      })
      .finally(() => {
        console.log();
      });
  }

  async startBasicCall() {
    // Create an AgoraRTCClient object.
    this.rtc.client = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });

    // Listen User joined room
    this.rtc.client.on('user-joined', (user) => {
      this.isUserJoined = true;
      this.isUserLeaved = false;
    });

    // Listen User left room
    this.rtc.client.on('user-left', (user) => {
      this.isUserLeaved = true;
      this.isUserJoined = false;
    });

    // Listen for the 'user-published' event, from which you can get an AgoraRTCRemoteUser object.
    this.rtc.client.on('user-published', async (user, mediaType) => {
      // Subscribe to the remote user when the SDK triggers the 'user-published' event
      await this.rtc.client.subscribe(user, mediaType, {
        audio: {
          codec: 'opus',
          noiseSuppression: true, // Bật khử tiếng ồn
          echoCancellation: true, // Bật echo cancellation
        },
        video: {
          fec: true,
        },
      });
      console.log('subscribe success');

      // If the remote user publishes a video track.
      if (mediaType === 'video') {
        // Get the RemoteVideoTrack object in the AgoraRTCRemoteUser object.
        const remoteVideoTrack = user.videoTrack;
        // Dynamically create a container in the form of a DIV element for playing the remote video track.
        const remotePlayerContainer = document.createElement('div');
        // Specify the ID of the DIV container. You can use the uid of the remote user.
        remotePlayerContainer.id = user.uid.toString();
        // remotePlayerContainer.textContent = 'Remote user ' + user.uid.toString();
        remotePlayerContainer.style.width = '100%';
        remotePlayerContainer.style.height = 'calc(100vh - 12vh)';
        const videoContent = document.getElementById('video-content');
        videoContent.append(remotePlayerContainer);
        // document.body.append(remotePlayerContainer);

        // Play the remote video track.
        // Pass the DIV container and the SDK dynamically creates a player in the container for playing the remote video track.
        // remoteVideoTrack.play(remotePlayerContainer);
        remoteVideoTrack.play(remotePlayerContainer, { fit: 'contain', mirror: false });
      }

      // If the remote user publishes an audio track.
      if (mediaType === 'audio') {
        this.userMicOff = false;
        // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
        const remoteAudioTrack = user.audioTrack;
        // Play the remote audio track. No need to pass any DOM element.
        remoteAudioTrack.play();
      }

      // Listen for the 'user-unpublished' event
      this.rtc.client.on('user-unpublished', (user, mediaType) => {
        // Get the dynamically created DIV container.
        const remotePlayerContainer = document.getElementById(user.uid);
        // Destroy the container.

        // If the remote user publishes an audio track.
        if (mediaType === 'audio') {
          this.userMicOff = true;
        }
        if (mediaType === 'video') {
          remotePlayerContainer.remove();
        }
      });
    });
  }

  async joinCalling() {
    this.isCanJoin = false;

    // document.getElementById('join').onclick = async function () {
    // Join an RTC channel.
    await this.rtc.client.join(
      this.options.appId,
      this.options.channel,
      this.options.token,
      this.options.uid,
    );
    // Create a local audio track from the audio sampled by a microphone.
    this.rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
      encoderConfig: {
        bitrate: 32,
        sampleRate: 32000,
        codec: 'opus',
      },
      AEC: true,
      AGC: true,
      ANS: true,
    });
    // Create a local video track from the video captured by a camera.
    this.rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
    // Publish the local audio and video tracks to the RTC channel.
    await this.rtc.client.publish([
      this.rtc.localAudioTrack,
      this.rtc.localVideoTrack,
    ]);
    // Dynamically create a container in the form of a DIV element for playing the local video track.
    const localPlayerContainer = document.createElement('div');
    // Specify the ID of the DIV container. You can use the uid of the local user.
    localPlayerContainer.id = this.options.uid;
    // localPlayerContainer.textContent = 'Local user ' + this.options.uid;
    localPlayerContainer.style.width = '200px';
    localPlayerContainer.style.height = '200px';
    const videoContentUser = document.getElementById('video-content-user');
    videoContentUser.append(localPlayerContainer);

    // Play the local video track.
    // Pass the DIV container and the SDK dynamically creates a player in the container for playing the local video track.
    this.rtc.localVideoTrack.play(localPlayerContainer);

    // When token-privilege-will-expire occurs, fetch a new token from the server and call renewToken to renew the token.
    this.rtc.client.on('token-privilege-will-expire', async function() {
      const response = await ApiHelper.getApi('ChannelApi')
        .agoraToken(self.currentChannel.id, {
          with: 'users,latest_message,users.latestReservation',
        });
      await self.rtc.client?.renewToken(response.data.token);
    });

    if (!this.hasCamera) {
      await this.rtc.localVideoTrack.setEnabled(false);
    }
    if (!this.hasMic) {
      await this.rtc.localAudioTrack.setEnabled(false);
    }
    console.log('publish success!');

    this.rtc.client.on('network-quality', async (stats) => {
      await this.handleNetworkQuantity(stats, localPlayerContainer);
    });

    this.isCall = true;
    this.isCanJoin = true;
  }

  async leaveCalling() {
    // Destroy the local audio and video tracks.
    this.rtc.localAudioTrack.close();
    this.rtc.localVideoTrack.close();

    // Traverse all remote users.
    this.rtc.client.remoteUsers.forEach((user) => {
      // Destroy the dynamically created DIV containers.
      const playerContainer = document.getElementById(user.uid);
      playerContainer && playerContainer.remove();
    });

    // Leave the channel.
    await this.rtc.client.leave();
    this.resetCallState();
    this.setVideoCall(false);
    this.$modal.hide('video-component');
  }

  beforeDestroy() {
    this.rtc.client.leave();
    this.setVideoCall(false);
  }

  async handleNetworkQuantity(stats, localPlayerContainer) {
    const networkQuantity = stats.uplinkNetworkQuality;

    if (this.rtc.networkQuantity == networkQuantity) {
      return;
    }

    this.rtc.networkQuantity = networkQuantity;
    const localVideoContentUser = document.getElementById('video-content-user');

    if (this.networkStatus.HIGH.quantity.includes(networkQuantity) ||
      this.networkStatus.MEDIUM.quantity.includes(networkQuantity)) {
      this.rtc.localVideoTrack.setEnabled(true);
      this.rtc.localVideoTrack.play(localPlayerContainer);
      await this.rtc.client.publish([this.rtc.localVideoTrack, this.rtc.localAudioTrack]);

      if (localVideoContentUser) {
        localVideoContentUser.style.display = 'flex';
      }
    }

    if (this.networkStatus.HIGH.quantity.includes(networkQuantity)) {
      this.rtc.networkStatus = this.networkStatus.HIGH.name;
      this.rtc.localVideoTrack.setEncoderConfiguration({
        width: 640,
        height: 480,
        frameRate: 30,
        bitrate: 1000,
        bitrateMax: 1200,
      });
    } else if (this.networkStatus.MEDIUM.quantity.includes(networkQuantity)) {
      this.rtc.networkStatus = this.networkStatus.MEDIUM.name;
      this.rtc.localVideoTrack.setEncoderConfiguration({
        width: 640,
        height: 480,
        frameRate: 10,
        bitrate: 300,
      });
    } else if (this.networkStatus.LOW.quantity.includes(networkQuantity)) {
      this.rtc.networkStatus = this.networkStatus.LOW.name;

      if (localVideoContentUser) {
        localVideoContentUser.style.display = 'none';
      }
      this.rtc.localVideoTrack.setEnabled(false);
      this.rtc.localVideoTrack.stop();
      await this.rtc.client.publish([this.rtc.localVideoTrack, this.rtc.localAudioTrack]);
    } else if (this.networkStatus.DISCONNECT.quantity.includes(networkQuantity)) {
      this.rtc.networkStatus = this.networkStatus.DISCONNECT.name;
    }
  }

  showPlanListModal() {
    this.$modal.show('plan-list-popup');
    setTimeout(() => {
      this.isShowPlanListModal = !this.isShowPlanListModal;
    }, 200);
  }
}
</script>

<style lang='scss'>
#video-content>div {
  width: 100%;
  height: 100% !important;
  border: 3px solid darkslategray;
  border-radius: 10px;
  overflow: hidden;
}

#video-content-user>div {
  width: 200px;
  height: 100%;
  margin-left: 10px;
  border: 3px solid darkslategray;
  border-radius: 10px;
  overflow: auto;
}

.video {
  &-component {
    height: 0 !important;
    position: relative !important;

    &.is-not-chat-tab {
      height: 0;

      .v--modal-box {
        width: 500px !important;
        height: 350px !important;
        max-width: 100vw !important;
        position: fixed !important;
      }

      .video-container {
        height: 350px;
      }

      .video-content-user > div {
        width: 130px !important;
        height: 130px !important;
      }

      .video-user {
        width: 130px;
        height: 130px;
      }

      .video-content {
        height: 57% !important;
      }

      @media (max-width: 767px) {
        .v--modal-box {
          width: 100% !important;
          height: 40vh !important;
          left: 0 !important;
          top: 0 !important;
        }

        .video-body {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
        }

        .video-container {
          height: auto;
          flex: 1;
          min-height: 0;
        }

        .video-content {
          height: 100% !important;
        }

        .video-content-user {
          position: absolute;
          right: 18px;
          bottom: 10px;
          height: auto;
          padding: 0;
          z-index: 100;
        }
      }
    }

    &.is-chat-tab {
      .v--modal-box {
        width: 540px !important;
        height: 350px !important;
        max-width: 100vw !important;
        position: fixed !important;
      }

      .video-container {
        height: 350px;
      }

      .video-content-user > div {
        width: 130px !important;
        height: 130px !important;
      }

      .video-user {
        width: 130px;
        height: 130px;
      }

      .video-content {
        height: 57% !important;
      }

      // Docked at the top of the viewport on mobile so the plan-list popup
      // (PlanListPopup.vue) can be stacked below it instead of overlapping.
      @media (max-width: 767px) {
        .v--modal-box {
          width: 100% !important;
          height: 40vh !important;
          left: 0 !important;
          top: 0 !important;
        }

        .video-body {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
        }

        .video-container {
          height: auto;
          flex: 1;
          min-height: 0;
        }

        .video-content {
          height: 100% !important;
        }

        .video-content-user {
          position: absolute;
          right: 18px;
          bottom: 10px;
          height: auto;
          padding: 0;
          z-index: 100;
        }
      }
    }

    &.is-fullscreen {
      .v--modal-box {
        width: 100vw !important;
        height: 100vh !important;
        top: 0 !important;
        left: 0 !important;
        margin: 0 !important;
      }

      .video-container {
        height: calc(100vh);
      }

      .video-header {
        font-size: 14px;
      }

      .video-content-user > div {
        width: 160px !important;
        height: 160px !important;
      }

      .video-user {
        width: 160px;
        height: 160px;
      }

      .video-content {
        height: calc(100vh - 220px) !important;
      }

      .fullscreen-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        background: transparent;
        border: none;
        padding: 6px;
        cursor: pointer;

        svg {
          width: 20px;
          height: 20px;
          color: #fff;
        }
      }
    }

    .video-controls {
      position: absolute;
      top: 45px;
      right: 5px;
      z-index: 9;
      display: flex;
      align-items: center;
      gap: 7px;

      button {
        border: 2px solid #fff;
        border-radius: 4px;
        background: transparent;
        padding: 2px 4px;

        &:focus {
          outline: none;
        }
      }
    }

    @media (max-width: 767px) {
      .video-controls {
        top: 8px;
        z-index: 20;
      }
    }
  }

  &-header {
    background-color: #000;
    padding: 10px;
    color: #fff;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    font-size: 12px;

    span {
      margin-left: 10px;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: wrap;
      flex-shrink: 0;
      gap: 4px;
      padding-right: 40px;

      > div {
        width: 100%;
        min-width: 0;
      }

      // Reset the network-status span's height:0/position:relative (inherited
      // from the unrelated .video-component modal class) so it doesn't
      // collapse and overlap the title/notification on narrow screens.
      .video-component {
        height: auto !important;
        position: static !important;
        display: inline-block;
        white-space: normal;
        word-break: break-word;
      }
    }
  }

  &-content {
    z-index: 1;
    height: 80%;
    padding: 10px;
    padding-bottom: 0;

    @media (max-width: 767px) {
      box-sizing: border-box;
    }
  }

  &-item {
    padding: 10px 10px 0;
    z-index: 1000;
  }

  &-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    position: absolute;
    bottom: -12px;
    width: 100%;
    padding: 10px 10px 10px;
  }

  &-btn {
    color: #fff;
    font-weight: bold;
    border-radius: 6px;
    padding: 10px;
    border: unset;

    &-call {
      background: #008505;
    }

    &-end {
      background: #fc1d1d;
    }

    &-plan {
      background: #008505;
    }
  }

  &-container {
    position: relative;
    height: 90vh;
    background-color: #263238;
  }

  &-notification {
    background: black;
    color: rgb(94, 255, 51);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    animation: slide-right-left 0.5s ease-out;
  }

  @keyframes slide-right-left {
    from {
      transform: translateX(100%);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  &-user {
    position: absolute;
    right: 18px;
    bottom: 10px;
    width: 200px;
    height: 200px;
    z-index: 100;
    background-color: transparent;
  }
}

.video-content-user {
  height: 20%;
  padding: 10px;
  display: flex;
  flex-direction: row-reverse;
}

.mic-icon-user {
  position: absolute;
  top: 58px;
  z-index: 1000;
  height: 30px;
  left: 20px;
}

.network-high {
  background: rgba(131, 128, 128, 0.6);
  color: #5eff33;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.network-medium {
  background: rgba(131, 128, 128, 0.6);
  color: #ffca33;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.network-low {
  background: rgba(131, 128, 128, 0.6);
  color: #ff3333;
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}
</style>
